// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-3ySeK";
var _3 = "notification-5k9_K";
var _4 = "notificationText-1lGNk";
var _5 = "notificationIcon-2w0a6";
export { _1 as "__esModule", _2 as "wrapper", _3 as "notification", _4 as "notificationText", _5 as "notificationIcon" }
export default { "__esModule": _1, "wrapper": _2, "notification": _3, "notificationText": _4, "notificationIcon": _5 }
